import { Language } from '../LanguageSelectDialog';

interface GetLanguagesSortedProps {
    languages: Language[];
    selectedLanguage: Language | undefined;
}

export const getLanguagesSorted = ({ languages, selectedLanguage }: GetLanguagesSortedProps) => {
    if (!selectedLanguage) {
        return languages;
    }

    const languagesFiltered = languages.filter(({ code }) => code !== selectedLanguage.code);

    languagesFiltered.unshift(selectedLanguage);

    return languagesFiltered;
};
